import * as React from "react";
import { lazy, Suspense } from "react";
import Dump from "../../js/components/dump.tsx";
import { arrayUnique, slugify } from "../../js/helpers/utils.ts";
import RenderItem from "../../js/render/renderItem.tsx";
import type { RenderClasses } from "../../js/render/renderSection.tsx";
import { ContentRenderMode } from "../../js/enums";
import type { PageSectionData } from "../../js/page/content.types";
import { clsx } from 'clsx';

const VimeoIframe = lazy(() => import('../../js/components/vimeoIframe'));

export const sectionClassDefault = ['section', 'h-full', 'relative'];
export const sectionCenteringWrapperClassDefault = ['mx-auto', 'h-full', 'z-20', 'relative'];
export const sectionInnerClassDefault = ['flex', 'flex-wrap', 'transform-gpu'];
export const itemLayoutClassDefault = [];
export const flexClassDefault = [];

function getSectionId(section: PageSectionData, index: number): string {
	return (section?.id) ? slugify(section.id) : 'section' + index;
}

function getItemId(sectionId: string, index: number): string {
	return sectionId + '_' + index;
}

function renderOffsetAnchor(section: PageSectionData, index: number, mode = ContentRenderMode.NORMAL) {
	if (mode !== ContentRenderMode.SLIDER) { //&& mode !== ContentRenderMode.REUSE_SECTION) {
		if (mode === ContentRenderMode.NORMAL || section?.id) {
			return (
				<div id={getSectionId(section, index)} className="offsetAnchor"/>
			);
		}
	}
	return null;
}

export default function renderSectionCustom(section: PageSectionData, mode: ContentRenderMode, indexSection: number, classes: RenderClasses) {
	return (<>
		{/*{<Dump label="vimeo" value={isSectionWithVideo(section) === false}/>}*/}
		{/*<Dump label="sectionClasses" value={classes}/>*/}

		{renderOffsetAnchor(section, indexSection, mode)}

		<section className={clsx(classes.section)}>
			{/*{section?.class === 'header' && <div className="absolute inset-x-0 inset-y-0 bg-repeat-x bg-bottom z-10 pointer-events-none"/>}*/}
			{section?.vimeoId && <>
				{/*<div className="absolute inset-x-0 inset-y-0 bg-primary-200/50 bg-repeat-x bg-bottom z-10 pointer-events-none"/>*/}

				<div className={clsx("absolute inset-x-0 inset-y-0 z-10 transform-gpu", classes.sectionBgImage)}>
					<div className="w-full h-full overflow-hidden relative">
						<Suspense fallback={null}>
							<VimeoIframe
								videoId={section.vimeoId}
								autoplay={true}
								muted={true}
								loop={true}
								className="w-[177.777777vh] h-[56.25vw] min-w-full min-h-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
							/>
						</Suspense>
					</div>
				</div>
			</>}

			<div className={clsx(classes.sectionCenteringWrapper)}>
				<div className={clsx(arrayUnique(classes.sectionInner.concat(classes.flex)))}>
					{section?.items?.map((item, indexItem) =>
						<RenderItem
							key={getItemId(getSectionId(section, indexSection), indexItem)}
							item={item}
							itemId={mode === ContentRenderMode.NORMAL ? getItemId(getSectionId(section, indexSection), indexItem) : null}
							itemLayoutClass={classes.itemLayout}
							indexSection={indexSection}
							indexItem={indexItem}
						/>
					)}
				</div>
			</div>
		</section>
	</>);
}
